module.exports = __webpack_public_path__ + "static/media/favorite_gray_filled.4317b5bb.svg";